// Public delivery host verified against this library's Bunny embed response.
// Keep API keys and signing secrets on the server. Unknown libraries use Bunny's embed.
const DELIVERY_HOSTS = { '677808': 'vz-30a45a09-aa2.b-cdn.net' };
const FM_PAPER_ID = 'P6EjMBX6V25ScyKSOzs4';
export function prefersStandardVideo(paper = {}) {
    const name = String(paper.name || paper.paperName || '').trim();
    return (paper.id || paper.paperId) === FM_PAPER_ID || /^fm(?:\b|$)/i.test(name) || /^financial management(?:\b|$)/i.test(name);
}
export function bunnyMp4Sources(libraryId, videoId) {
    const host = DELIVERY_HOSTS[String(libraryId).trim()];
    const id = String(videoId || '').trim();
    if (!host || !/^[a-f\d]{8}(?:-[a-f\d]{4}){3}-[a-f\d]{12}$/i.test(id)) return null;
    return Object.fromEntries(['720', '480'].map(quality => [quality, `https://${host}/${id}/play_${quality}p.mp4`]));
}
